import React from 'react';
import { Link } from 'react-router-dom';

const MeetingRoom: React.FC = () => {
  const rooms = [
    {
      name: '台中 1602B',
      capacity: 6,
      description: '小型會議室',
      image: '/rooms/1602B.jpg',
      link: '/meetings/1602b/reserve',
      active: true
    },
    {
      name: '台中 1607B',
      capacity: 8,
      description: '小型錄音會議室',
      image: '/rooms/unavailable-light.jpg',
      active: false
    },
    {
      name: '台中 1607A',
      capacity: 25,
      description: '中型培訓會議室',
      image: '/rooms/unavailable-light.jpg',
      active: false
    },
    {
      name: '台中 1602A',
      capacity: 30,
      description: '中型活場地',
      image: '/rooms/unavailable-light.jpg',
      active: false
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-2xl font-bold text-white">會議室預約</h1>
        <p className="text-white/60 text-sm">Monospace 會員專屬會議空間</p>
      </div>

      <div className="flex flex-col gap-4">
        {rooms.map((room, idx) => (
          <div key={idx} className="group overflow-hidden rounded-2xl border border-white/10 bg-white/5 transition-all hover:border-primary/30">
            <div className="relative h-40 w-full overflow-hidden">
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/0 transition-colors z-10"></div>
              <img
                src={room.image}
                alt={room.name}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              {!room.active && (
                <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/60 backdrop-blur-[2px]">
                  <span className="rounded-full border border-white/20 bg-black/50 px-4 py-1 text-sm font-bold text-white/80">
                    暫停預約
                  </span>
                </div>
              )}
            </div>
            <div className="flex items-center justify-between p-4">
              <div>
                <h3 className="font-bold text-white">{room.name}</h3>
                <p className="text-xs text-white/60 mt-0.5">{room.description}</p>
                <div className="flex items-center gap-1 text-xs text-white/50 mt-2">
                  <span className="material-symbols-outlined text-sm">group</span>
                  <span>{room.capacity} 人</span>
                </div>
              </div>
              {room.active ? (
                <Link
                  to={room.link!}
                  className="rounded-full bg-primary px-4 py-2 text-xs font-bold text-black shadow-lg shadow-primary/20 hover:bg-primary/90 active:scale-95 transition-transform"
                >
                  預約
                </Link>
              ) : (
                <button
                  disabled
                  className="rounded-full bg-white/10 px-4 py-2 text-xs font-bold text-white/30 cursor-not-allowed"
                >
                  預約
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MeetingRoom;